import { Checkbox } from "@/components/ui/checkbox";
import {
  EMPTY_FILTER_VALUE,
  NOT_BLANK_FILTER_VALUE,
  displayValueInList,
} from "./dashboard-column-filter-match";

/**
 * Blank and not-blank choices pinned above a column's value list.
 * They stay available even when the current suggestions omit empty rows.
 */
export function ColumnPresenceFilterChoices({
  idPrefix,
  values,
  onToggle,
}: {
  idPrefix: string;
  values: readonly string[];
  onToggle: (value: string) => void;
}) {
  return (
    <div className="flex flex-col gap-2 border-b px-3 py-2">
      <PresenceChoice
        id={`${idPrefix}-blank`}
        label="Blank"
        checked={displayValueInList(values, EMPTY_FILTER_VALUE)}
        onToggle={() => onToggle(EMPTY_FILTER_VALUE)}
      />
      <PresenceChoice
        id={`${idPrefix}-not-blank`}
        label="Not blank"
        checked={displayValueInList(values, NOT_BLANK_FILTER_VALUE)}
        onToggle={() => onToggle(NOT_BLANK_FILTER_VALUE)}
      />
    </div>
  );
}

function PresenceChoice({
  id,
  label,
  checked,
  onToggle,
}: {
  id: string;
  label: string;
  checked: boolean;
  onToggle: () => void;
}) {
  return (
    <div className="flex items-center gap-2">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={onToggle}
        onClick={(event) => event.stopPropagation()}
      />
      <label
        htmlFor={id}
        className="cursor-pointer text-xs font-medium text-muted-foreground"
      >
        {label}
      </label>
    </div>
  );
}
